import React from "react";
// ANT DESIGN COMPONENTS
import { Divider, Tooltip, Button, message } from "antd";
// DEVICE DETECT
import { isMobile } from "react-device-detect";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faServer, faCopy } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useSelector } from "react-redux";
// INTERFACES
import { RootState } from "../../../app/store";
// FLATBUFFER DISPLAY HELPERS
import { formatUuidT } from "../../../flatbuffers/display";

function DrawerServerInformation({ data }: any) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { theme } = useSelector((state: RootState) => state.home);
  const [t] = useTranslation("global");

  // ************************************************ */
  // FUNCTIONS ************************************** */
  // server.id may arrive as a raw FlatBuffer UuidT (`{ value: Uint8Array }`)
  // or as an already-formatted string, depending on the callsite. Coerce to
  // a string once so the JSX can safely render and the copy button writes a
  // useful value. Without this, React throws "Objects are not valid as a
  // React child" and blanks the page.
  const formattedId = data && data.id ? formatUuidT(data.id) : "";

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <br />
      {/** ************************************************* */}
      {/** SERVER INFORMATION */}
      <div>
        <Divider orientation="left" className="generalStyles__drawerDivider">
          <h5>
            <FontAwesomeIcon icon={faServer} className="generalStyles__info generalStyles__mrFix" />
            {t("edgeManagement.servers.serverInformation")}
          </h5>
        </Divider>
      </div>
      <div className={`drawer__box__${theme}`}>
        {/* ID */}
        <div className="generalStyles__flex">
          <div>
            <p className={isMobile ? "drawer__titleMobile" : "drawer__title"}>ID:</p>
          </div>
          <div
            className="drawer__textContainer"
            style={{ display: "flex", alignItems: "center", gap: 4 }}
          >
            <p className="drawer__text" style={{ margin: 0, flex: 1 }}>
              {formattedId !== "" ? formattedId : "--"}
            </p>
            {formattedId !== "" && (
              <Tooltip title="Copy ID">
                <Button
                  type="text"
                  size="small"
                  icon={<FontAwesomeIcon icon={faCopy} style={{ fontSize: 11 }} />}
                  onClick={() => {
                    navigator.clipboard.writeText(formattedId);
                    message.success("Server ID copied");
                  }}
                  style={{ opacity: 0.5, minWidth: 24 }}
                />
              </Tooltip>
            )}
          </div>
        </div>
        {/* NAME */}
        <div className="generalStyles__flex">
          <div>
            <p className={isMobile ? "drawer__titleMobile" : "drawer__title"}>
              {t("edgeManagement.servers.serverName")}
            </p>
          </div>
          <div className="drawer__textContainer">
            <p className="drawer__text">{data && data.name ? data.name : "--"}</p>
          </div>
        </div>
        {/* IP */}
        <div className="generalStyles__flex">
          <div>
            <p className={isMobile ? "drawer__titleMobile" : "drawer__title"}>
              {t("edgeManagement.servers.ip")}
            </p>
          </div>
          <div className="drawer__textContainer">
            <p className="drawer__text">{data && data.ip ? data.ip : "--"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DrawerServerInformation;
